import RatingItem from "../pages/Interview/GlobalClassification/RatingItem";
import IconClear from "../layout/others/icon_clear.svg";
export default function EditRating({ onChange, ratingObj }) {
  function clearRating() {
    onChange(0);
  }
  return (
    <div className="input-group">
      <span className="form-control">
        <RatingItem onChange={onChange} skill={ratingObj} />
      </span>
      <button className="btn btn-outline-secondary" onClick={clearRating}>
        <img
          src={IconClear}
          alt="ico-ppl"
          width="auto"
          style={{ verticalAlign: "central" }}
        />
      </button>
    </div>
  );
}
